<template> 
  <div class="resource" v-if="resource.display">
    <div class="resourcePreview">
      <img :src="resource.Thumbnail" v-if="resource.Thumbnail" class="resourceThumb">
      <img src="https://assets-cdn.carwars.com/call-box/linkIcon.PNG" v-if="!resource.Thumbnail" class="resourceThumb">
    </div>

    <label class="resourceName sub" :class="{linkTitle: resource.ResourceType === 'link'}">
      <a :href="resource.Resource" @click="logEvent(resource.id)" class="link" target="_blank">
        {{resource.Name}}
      </a>
    </label>
  </div>
</template>

<script type="text/javascript">
	export default {
    name: 'resourceItem',
    props: ['resource'],
    methods:{
    	logEvent: function(resourceid) {
        	this.$store.dispatch('logResourceEvent', resourceid);
      	},
    }
  }
</script>